import { render, staticRenderFns } from "./KnowledgeShow.vue?vue&type=template&id=0f72409a"
import script from "./KnowledgeShow.vue?vue&type=script&lang=js"
export * from "./KnowledgeShow.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeShow.vue?vue&type=style&index=0&id=0f72409a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports